/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the BSD 3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { FunctionalComponent, h } from '@stencil/core';
import { JSXBase } from '@stencil/core/internal';

export const FortifyLogo: FunctionalComponent<JSXBase.SVGAttributes<SVGElement>> = (props) => (
  <svg
    {...props}
    width="40"
    height="40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="url(#paint0_linear_2707_3133)" d="M17.694 28.19s.747-7.399.809-8.64a3.17 3.17 0 0 1-1.653-2.79A3.16 3.16 0 0 1 20 13.59a3.16 3.16 0 0 1 3.15 3.17 3.171 3.171 0 0 1-1.66 2.794c.063 1.23.816 8.634.816 8.634h-4.612v.002Zm15.431-21.7c-.155 0-.235-.002-.316-.003l-.191-.004A18.418 18.418 0 0 1 20 1c-3.352 3.392-7.995 5.49-13.125 5.49a18.23 18.23 0 0 1-.829-.018 16.832 16.832 0 0 1-.954-.068L5 6.406v9.146a25.686 25.686 0 0 0 14.56 23.197l.213.101a.629.629 0 0 0 .227.045.579.579 0 0 0 .22-.043A25.683 25.683 0 0 0 35 15.552v-9.14c-.042 0-.084 0-.125-.003-.575.055-1.16.084-1.75.084v-.002Z" />
    <path stroke="url(#paint1_linear_2707_3133)" stroke-width=".5" d="M18.179 19.726a3.488 3.488 0 0 1-1.641-2.966c0-1.926 1.55-3.486 3.462-3.486 1.913 0 3.462 1.56 3.462 3.486a3.493 3.493 0 0 1-1.65 2.971c.046.628.175 2.05.368 4.022.012.143.012.143.027.285.088.92.185 1.888.282 2.845l.095.922.035.35.035.346h-5.306l.035-.348.035-.348.092-.92c.095-.955.19-1.923.279-2.841.016-.148.016-.148.03-.297.19-1.973.319-3.394.362-4.026l-.002.005ZM5.094 6.722V6.72H5.1h-.006v.002Zm.218.02v8.81c0 9.888 5.67 18.742 14.382 22.915l.19.09a.334.334 0 0 0 .206.01c8.829-4.125 14.598-13.041 14.598-23.014v-8.81c-.526.044-1.046.065-1.563.065-.091 0-.142 0-.24-.003h-.08c-.047-.002-.047-.002-.096-.002l-.1-.003A18.718 18.718 0 0 1 20 1.442 18.691 18.691 0 0 1 6.875 6.808c-.15 0-.303 0-.463-.006a18.799 18.799 0 0 1-1.1-.06Z" clip-rule="evenodd" />
    <defs>
      <linearGradient id="paint0_linear_2707_3133" x1="20" x2="20" y1="1" y2="38.895" gradientUnits="userSpaceOnUse">
        <stop stop-color="#4DA3FC" />
        <stop offset="1" stop-color="#027EFF" />
      </linearGradient>
      <linearGradient id="paint1_linear_2707_3133" x1="19.891" x2="19.891" y1="38.58" y2="1.442" gradientUnits="userSpaceOnUse">
        <stop stop-color="#49A1FC" />
        <stop offset="1" stop-color="#0680FF" />
      </linearGradient>
    </defs>
  </svg>
);
